import { render } from "./ButtonGroup.vue?vue&type=template&id=e492b028&scoped=true"
const script = {}

import "./ButtonGroup.vue?vue&type=style&index=0&id=e492b028&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e492b028"]])

export default __exports__